import type {
    CardPointeCredentials,
    CardPointeCredentialsPublic,
    CardPointeCredentialsSecret,
} from './cardpointe-credential.types';
import { CardPointeThirdPartySystemId } from './cardpointe-system-constants';

export const CardPointeCredentialResolutionOutcome = {
    RESOLVED: 'resolved',
    INVALID_CREDENTIALS: 'invalid_credentials',
} as const;

export type CardPointeCredentialResolutionOutcome =
    (typeof CardPointeCredentialResolutionOutcome)[keyof typeof CardPointeCredentialResolutionOutcome];

export interface CardPointeCredentialResolutionRequest {
    readonly systemId: typeof CardPointeThirdPartySystemId;
    readonly publicCredentials: CardPointeCredentialsPublic;
    readonly secretCredentials: CardPointeCredentialsSecret;
    readonly credentialUuid?: string;
}

export interface CardPointeCredentialResolutionNormalizedResult {
    readonly credentials: CardPointeCredentials;
}

export type CardPointeCredentialResolutionResponse =
    | {
          readonly outcome: typeof CardPointeCredentialResolutionOutcome.RESOLVED;
          readonly normalizedResult: CardPointeCredentialResolutionNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeCredentialResolutionOutcome.INVALID_CREDENTIALS;
          readonly message: string;
      };
